import { Link } from "react-router-dom";
import "./botonInstructivo.css";

export default function BotonInstructivo({ to, sobreColor = false, className = "" }) {
  return (
    <Link
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn-instructivo${sobreColor ? " btn-instructivo--sobre-color" : ""}${className ? ` ${className}` : ""}`}
      aria-label="Abrir instructivo en una pestaña nueva"
    >
      <i className="pi pi-book" aria-hidden="true" />
      <span>Instructivo</span>
    </Link>
  );
}
